// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"16d040ec","102":"16d040ec","343":"7b789f3e","395":"16d040ec"}[chunkId] + ".chunk.css";
};